export const employmentType = [
  {
    id: 1,
    name: 'Full-time',
  },
  {
    id: 2,
    name: 'Contract',
  },
  {
    id: 3,
    name: 'Part-time',
  },
  {
    id: 4,
    name: 'Internship',
  },
];
